import React from "react";
import { useNavigate } from "react-router-dom";
import useWriting from "../../hooks/useWriting";
import "./WritingList.css"; // optional styles

const WritingList = () => {
  const { writings, loading } = useWriting();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="writing-loading">
        <div className="loading-spinner"></div>
        <p>Loading writing...</p>
      </div>
    );
  }

  return (
    <div className="writing-list-page">
      <div className="writing-header">
        <h1 className="writing-heading">✍️ Writing</h1>
        <p className="writing-subtitle">{writings.length} published works</p>
      </div>

      <div className="writing-grid">
        {writings.map((piece) => (
          <div
            key={piece.slug}
            className="writing-card"
            onClick={() => navigate(`/writing/${piece.slug}`)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                navigate(`/writing/${piece.slug}`);
              }
            }}
          >
            <div className="writing-card-image-wrapper">
              <img
                src={piece.thumbnail}
                alt={piece.title}
                className="writing-thumb"
                loading="lazy"
              />
              <div className="writing-card-overlay">
                <span className="writing-card-view-icon">📖</span>
              </div>
            </div>
            <h3 className="writing-card-title">{piece.title}</h3>
          </div>
        ))}
      </div>

      <div className="amazon-button-wrapper">
        <a
          href="https://www.amazon.com/stores/Sam-Vary/author/B00Y63219K"
          target="_blank"
          rel="noopener noreferrer"
          className="amazon-button"
        >
          <span className="amazon-button-icon">📚</span>
          <span>Visit My Amazon Author Page</span>
          <span className="amazon-button-arrow">→</span>
        </a>
      </div>
    </div>
  );
};

export default WritingList;
